import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ExternalTeacherVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const retrieveExternalTeacher = createAsyncThunk<ExternalTeacherVM, string, { extra: Partial<Dependencies> }>(
  "educationalAdvisor/externalTeacher/retrieve",
  async (id, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.getExternalTeacher(id);
  },
);

export const resetRetrieveExternalTeacher = createAction("educationalAdvisor/externalTeacher/resetRetrieve");
